/** @jsx jsx */
import { jsx } from '@emotion/react';

import type * as React from 'react';

import DomainEntityContext from 'bundles/browse-common/contexts/DomainEntityContext';
import { useDomainList } from 'bundles/browse-common/contexts/DomainListContext';
import type { KnownDomainSlugs } from 'bundles/browse-common/types/domain';
import { NotFound } from 'bundles/common/components/withNotFound';

type Props = {
  domainSlug: KnownDomainSlugs;
  children: React.ReactNode;
};

const DomainEntityProvider = (props: Props) => {
  const { domainSlug, children } = props;

  const context = useDomainList() ?? {};

  const { domains = [] } = context;

  const domain = domains.find((d) => d.slug === domainSlug);
  if (domains.length > 0 && !domain) {
    return <NotFound />;
  }

  return <DomainEntityContext.Provider value={domain ? { domain } : domain}>{children}</DomainEntityContext.Provider>;
};

export default DomainEntityProvider;
